export default __webpack_public_path__ + "static/media/wonderPig.48ce8a78.svg";